import PropTypes from "prop-types";
import AtomLinkButton from "components/source/atoms/atom-link-button";
import AtomProgressBar from "components/source/atoms/atom-progress-bar";
import { displayModal } from "actions/shared-actions";
import { useDispatch } from "react-redux";
import FitInformationModal from "components/source/new_taxonomy/fit-information-modal.jsx";

export default function FitRecommendationTooltip({ recommendations, sizeNames, getRecommendationType }) {
  const headerCopy = "Your Fit Match Scores";
  // Sizes in the recommendations are simple (M, L) whereas product sometimes has more descriptive (M Long, L Petite), which we prefer to display here
  const recommendationsWithDescriptiveSizes = recommendations.map(s => ({
    ...s,
    size: sizeNames?.[s.size] ? sizeNames[s.size] : s.size,
    percentage: s.percentage || Math.round(s.fitRate * 100),
  }));

  const dispatch = useDispatch();

  const displayFitModal = () => {
    dispatch(displayModal(FitInformationModal.MODAL_NAME));
  };

  const cta = (
    <AtomLinkButton className="capitalize" onClick={displayFitModal} bold={false}>
      How do we know?
    </AtomLinkButton>
  );

  const tooltipContents = (
    <div data-test-id="fit-rates-tooltip-content" className="flex flex-col gap-3 my-5">
      {recommendationsWithDescriptiveSizes
        .sort((a, b) => b.percentage - a.percentage)
        .sort((a, b) => Number(b.isRecommended) - Number(a.isRecommended))
        .map(({ percentage, size }) => {
          return (
            <div data-test-id="size-recommendations" key={size} className="w-full flex items-center gap-8">
              <span className="shrink-0">Size {size}</span>
              <AtomProgressBar
                className={`flex h-2.5 ${getRecommendationType(percentage) || "text-wine100"}`}
                progress={percentage}
              />
              <span>{percentage}%</span>
            </div>
          );
        })}
    </div>
  );

  return (
    <div data-test-id="fit-recommendation__tooltip" className="p-4 w-96">
      <p className="capitalize text-center">{headerCopy}</p>
      {tooltipContents}
      <p>{cta}</p>
    </div>
  );
}

FitRecommendationTooltip.propTypes = {
  getRecommendationType: PropTypes.func,
  recommendations: PropTypes.arrayOf(
    PropTypes.shape({
      isRecommended: PropTypes.bool,
      percentage: PropTypes.number,
      size: PropTypes.string,
      surveyCount: PropTypes.number,
    })
  ),
  sizeNames: PropTypes.object,
};
